import { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import PageTitle from '../../components/PageTitle'
import PrismTab from '../AllocationConfig/PrismTab'
import KnobsTab from '../AllocationConfig/KnobsTab'

// PRISM's iEDD knobs (kept separate from PACE's allocation knobs).
const PRISM_KNOB = (k) => k.group === 'prism-iedd'

/**
 * Intelligent EDD (PRISM) — the PRISM iEDD admin, split out of Allocation Config so
 * PACE (allocation) and PRISM (iEDD) each have their own page. The application layer is
 * unchanged: this reuses the same PrismTab + the shared decision-config API, just
 * scoped to PRISM's knobs. Lives under Delivery Performance.
 */
export default function IntelligentEDD() {
  const [tab, setTab] = useState(0)
  return (
    <div>
      <PageTitle>Intelligent EDD (PRISM)</PageTitle>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="iEDD" />
          <Tab label="Business Knobs" />
        </Tabs>
      </Box>
      {tab === 0 && <PrismTab />}
      {tab === 1 && <KnobsTab knobFilter={PRISM_KNOB} />}
    </div>
  )
}
